import 'twin.macro';
import React from 'react';
import { ExternalOrInternalLink } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/ExternalOrInternalLink';

interface Item {
  id: string;
  url?: string;
  internalLink?: string;
  label: string;
}

interface Props {
  items: Item[];
  labelPlural: string;
  label: string;
  className?: string;
}

export function Links(props: Props) {
  const { items, labelPlural, label, className } = props;
  return (
    <div className={className}>
      {items.length > 0 && (
        <span tw="mb-0 mr-1">
          <strong>{items.length > 1 ? labelPlural : label} : </strong>
        </span>
      )}
      <span tw="space-x-1">
        {items.map(a => (
          <ExternalOrInternalLink key={a.id} {...a} />
        ))}
      </span>
    </div>
  );
}
